import bilAPI from '../api';
import classicBilAPI from '../classicApi';
// import contentApi from '../contentApi';

export const getForms = ({ page, page_size, name, search }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/forms/form/`, {
          params: { page, page_size, name, search },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const getForm = (uuid, session) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/forms/form/${uuid}/`, { params: { session } })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

/**
 * Форма опроса за год экзамена (одна форма на год). Без exam_year бэк берёт
 * текущий год. Ответ: { uuid, exam_year, year, year_has_ended }, где
 * uuid === null — формы за этот год нет. Публичный (AllowAny) эндпоинт.
 */
export const getFormByYear = ({ exam_year, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/forms/form/by_year/`, {
          params: exam_year ? { exam_year } : undefined,
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const getFormSession = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/forms/form/${uuid}/get_or_create_session/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const postForm = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/forms/form/`, body)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const patchForm = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/forms/form/${uuid}/`, body)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const deleteForm = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/forms/form/${uuid}/`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

/**
 * Новый порядок вопросов после перетаскивания: uuid всех вопросов формы по
 * порядку. Бэк перенумеровывает их 1..n целиком (заодно чинит дубли order);
 * 400 STALE_ORDER — список не совпал с вопросами формы.
 */
export const postReorderContents = (uuid, contents) => {
  return new Promise((resolve, reject) => {
    try {
      classicBilAPI
        .post(`/forms/form/${uuid}/reorder/`, { contents })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

/**
 * Копия формы (вопросы и варианты, без ответов) на следующий год экзамена
 * со статусом CLOSED, либо на body.exam_year. Только SSA. 201 — новая форма;
 * 409 {error, code} — целевого года нет / он закончился / форма уже есть.
 */
export const postCopyForm = (uuid, body = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/forms/form/${uuid}/copy/`, body)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const postSubmitForm = (uuid, session) => {
  return new Promise((resolve, reject) => {
    try {
      classicBilAPI
        .post(`/forms/form/${uuid}/submit/`, { session })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const getFormResponse = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/forms/forms_answers/${uuid}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const getFormResponses = ({ form, page, page_size, uuid }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/forms/forms_answers/`, {
          params: { page, page_size, form, uuid },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const getFormUsers = ({ form, page, page_size }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/forms/forms_users/`, {
          params: { page, page_size, form },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};
